import draftToHtml from "draftjs-to-html";
import * as docxFunc from "../DocxTemplate/Docxhelper";
import {
  ContentState,
  convertFromRaw,
  convertToRaw,
  EditorState,
} from "draft-js";
import { emptyEditorContentPlainText } from "../../consts/consts";

export const getContentLength = (rawState) => {
  const content = convertFromRaw(JSON.parse(rawState));

  const editorState = EditorState.createWithContent(content);

  const contentState = editorState.getCurrentContent();
  const plainText = contentState.getPlainText();

  return plainText.length;
};

export const getDocxElementsFromString = (editorContent) => {
  const elementsInString = draftjsToString(editorContent)
    .split("\n")
    .map((x) => docxFunc.removeNonPrintableChars(x));

  return elementsInString.map((y) => {
    return docxFunc.textAnswer(y);
  });
};

export const draftjsToHTML = (text) => {
  try {
    if (isValidJson(text)) {
      const rawContentState = convertFromRaw(JSON.parse(text));

      const content = convertToRaw(rawContentState);

      const markup = draftToHtml(content);

      return markup;
    } else {
      return text;
    }
  } catch {
    return "";
  }
};

export const plainTextToEditorContent = (plainText) => {
  const content = ContentState.createFromText(plainText);

  return content;
};

export const rawToEditorContent = (rawState) => {
  const content = convertFromRaw(rawState);

  return content;
};

export const draftjsToString = (editorContent) => {
  let content = "";

  if (isValidJson(editorContent)) {
    content = JSON.parse(editorContent);
  } else if (
    editorContent == null ||
    editorContent === emptyEditorContentPlainText
  ) {
    return editorContent;
  } else {
    const jsonContentArray = extractJsonsWithPreText(editorContent);

    if(jsonContentArray.length === 0) {
      return editorContent;
    }

    const statesArray = jsonContentArray.flatMap(({ pre, json }) => [
      plainTextToEditorContent(pre),
      rawToEditorContent(json),
    ]);

    if (statesArray.length === 0) {
      const editorContent = plainTextToEditorContent(editorContent);
      const rawContent = convertToRaw(editorContent);
      content = rawContent;
    } else {
      const result = mergeContentStates(statesArray);
      content = result;
    }
  }

  const markers = ["•", "◦", "▪", "▪", "▪"];
  let list = [];

  const blocks = content.blocks
    ?.map((block) => {
      let marker = "";
      if (block.type === "ordered-list-item") {
        // Ensure the list is reset correctly when the depth decreases
        if (list[list?.length - 1]?.d > block.depth) {
          list = list.filter((x) => x.d <= block.depth);
        }

        // Find the value of the current depth or initialize it
        let depthIndex = list.findIndex((x) => x.d === block.depth);
        if (depthIndex === -1) {
          list.push({ d: block.depth, c: 1 });
          marker = "1. ";
        } else {
          list[depthIndex].c += 1;
          marker = `${list[depthIndex].c}. `;
        }
      } else if (block.type === "unordered-list-item") {
        list = [];
        marker = `${markers[block.depth]} `;
      } else {
        list = [];
      }

      // Replace tabs with spaces for proper indentation in PDF
      const indentation = "\u2003".repeat(block.depth * 2);
      return `${indentation}${marker}${block.text}`;
    })
    .join("\n");

  return blocks;
};

export const isValidJson = (value) => {
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return typeof parsed === "object" && parsed !== null;
    } catch (e) {
      return false;
    }
  }
  return false;
};

export const mergeContentStates = (contentStates) => {
  const mergedBlocks = [];
  const mergedEntityMap = {};

  contentStates.forEach((content) => {
    const rawContent = convertToRaw(content);

    const { blocks = [], entityMap = {} } = rawContent;

    blocks.forEach((block) => {
      mergedBlocks.push(block);
    });

    Object.keys(entityMap).forEach((key) => {
      if (!mergedEntityMap[key]) {
        mergedEntityMap[key] = entityMap[key];
      }
    });
  });

  return {
    blocks: mergedBlocks,
    entityMap: mergedEntityMap,
  };
};

/** This function is used to extract json content and pure content from post control note */
export const extractJsonsWithPreText = (text) => {
  if (typeof text !== "string") {
    throw new Error("Input must be a string");
  }

  const jsonStart = '\n{"blocks":';
  const jsonEnd = ',"entityMap":{}}\n';
  const resultArray = [];

  let startIndex = text.indexOf(jsonStart);
  let lastIndex = 0;

  while (startIndex !== -1) {
    const endIndex = text.indexOf(jsonEnd, startIndex);
    if (endIndex === -1) {
      break;
    }

    const jsonString = text.slice(
      startIndex + 1,
      endIndex + jsonEnd.length - 1
    );
    const preText = text.slice(lastIndex, startIndex);

    try {
      const jsonObject = JSON.parse(jsonString);
      resultArray.push({ pre: preText.trim(), json: jsonObject });
    } catch (e) {
      console.error("Invalid JSON:", jsonString);
    }

    lastIndex = endIndex + jsonEnd.length;
    startIndex = text.indexOf(jsonStart, lastIndex);
  }

  return resultArray;
};
